import { render, staticRenderFns } from "./posList.vue?vue&type=template&id=b40da864&scoped=true&"
import script from "./posList.vue?vue&type=script&lang=js&"
export * from "./posList.vue?vue&type=script&lang=js&"
import style0 from "./posList.vue?vue&type=style&index=0&id=b40da864&prod&scoped=true&lang=css&"
import style1 from "./posList.vue?vue&type=style&index=1&id=b40da864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40da864",
  null
  
)

export default component.exports